module.exports = __webpack_public_path__ + "static/pi4-966847b208b17cb561f3886311ba3da7.png";